import { NotificationService } from './notifications';

NotificationService.init();
export const notificationServiceInstance = NotificationService.getInstance();
